import { useEffect, useState, useContext } from "react";
import loginImg from "assets/images/loginImg.png";
import sabadiLog from "assets/images/logo-sabadi.png";
import { connection } from "utils/apiConnection.ts";
import Swal from "sweetalert2";
import AuthContext from "Authentication/AuthenticationContext.ts";

import loginimg from "assets/images/LogoMotion.png";
import logobgorange from "assets/images/logobgorange.PNG";
import Lottie from "react-lottie-player";
import Login_LogoMotion from "./Login_LogoMotion.json";
import CartItemsContext from "context/ShoppingCartItems";
// import { USER_TYPE } from "constants/constants.js";
export default function LogInNumber({
  ChangeModal,
  loginkey,
  ChangeModalStar,
  number,
  item,
  setItems,
}) {
  const [code, setcode] = useState("");
  const handleChange = (e) => {
    const value = e.target.value.replace(/\+|-/gi, "");
    setcode({ code: value });
  };
  const auth = useContext(AuthContext);
  const {
    shoppingData,
    updateShoppingList,
    currentInventory,
    prices,
    setPrices,
    itemsCount,
    itemsId,
    supplierCount,
    shoppingDataBusiness,
    setShoppingDataBusiness,
    getCount,
    isLoading,
    setIsLoading,
  } = useContext(CartItemsContext);
  let SetCode = (e) => {
    setcode(e.target.value);
  };

  useEffect(() => {
    (() => {
      "use strict";

      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      const forms = document.querySelectorAll(".needs-validation");
      // Loop over them and prevent submission
      Array.prototype.slice.call(forms).forEach((form) => {
        form.addEventListener(
          "submit",
          (event) => {
            if (!form.checkValidity()) {
              event.preventDefault();
              event.stopPropagation();
            }
            event.preventDefault();
            form.classList.add("was-validated");
          },
          false
        );
      });
    })();
  }, []);

  let SendCode = () => {
    connection("api/login", { mobile: number, hashcode: loginkey, code }).then(
      (data) => {
        console.log("dataaaaa", data.userinfo.id);
        if (data.status == 1) {
          auth.login(data.data.usertoken, data.userinfo);
          updateShoppingList();
          Swal.fire({
            title: "خوش آمدید",
            icon: "success",
            showConfirmButton: false,
            timer: 2000,
          });
          document.querySelector("#CloseModal").click();
          ChangeModal(0);
          ChangeModalStar(2);
          setItems(item + 1);
        } else if (data.status == 0) {
          Swal.fire({
            title: "خطا!",
            text: "لطفا دوباره امتحان کنید",
            type: "error",
            confirmButtonText: "باشه",
          });
        } else {
          Swal.fire({
            title: "خطا!",
            text: "شما مجاز نیستید",
            type: "error",
            confirmButtonText: "باشه",
          });
        }
      }
    );
  };
  return (
    <form
      className="needs-validation Login-number"
      noValidate
      onSubmit={SendCode}
    >
      <div style={{ backgroundColor: "#f1eae5" }}>
        <div className="d-flex flex-column "></div>

        {/* <div className="d-flex w-75  flex-column align-items-center justify-content-evenly ">
          <img src={sabadiLog} />
          <h4>ورود یا ثبت نام در سبدی</h4>
          <p className="text-center">
            برای ورود به سبدی کد دریافتی را وارد کنید
          </p>
          <input
            onChange={SetCode}
            value={code}
            type="number"
            style={{
              height: "50px",
              borderRadius: "15px",
              direction: "ltr",
              fontFamily: "digits",
              marginTop: "-10px ",
              marginBottom: "-10px "
            }}
            id="number"
            placeholder="کد دریافتی"
            className="form-control w-75 mx-auto"
            required
          />
          <div
            className="invalid-feedback text-start"
            style={{ marginRight: "63px" }}
          >
            لطفا کد دریافتی را وارد کنید
          </div>
          <label
            htmlFor="number"
            className="text-start  d-block my-3"
            style={{ marginRight: "63px", color: "#1D3354" }}
          >
            کد دریافتی را وارد کنید
          </label>
          <button
            type="submit"
            style={{
              height: "50px",
              borderRadius: "15px",
              backgroundColor: "#1A3764",
              color: "white"
            }}
            className="btn  mb-3 w-75"
          >
            ارسال
          </button>
        </div>
        <img src={loginImg} style={{ width: "50%", height: "500px" }} /> */}
        <div className=" d-flex justify-content-evenly container-login p-3">
          <div
            className="parent-login"
            style={{
              width: "320px",
              height: "400px",
              backgroundColor: "white",
            }}
          >
            <div
              style={{
                width: "100%",
                height: "100px",
                backgroundColor: "#ff4734",
                position: "relative",
                borderRadius: " 25px 25px 0px 0px",
                textAlign: "center",
              }}
            >
              <img
                src={logobgorange}
                style={{ width: "200px", height: "100px" }}
              ></img>
            </div>
            <div className="row px-4 pt-3 mt-3">
              <input
                onChange={SetCode}
                value={code}
                type="text"
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                style={{
                  height: "50px",
                  borderRadius: "15px",
                  direction: "ltr",
                  fontFamily: "digits",
                  marginTop: "-10px ",
                  marginBottom: "-10px ",
                  width: "100%",
                }}
                id="number"
                placeholder="کد دریافتی"
                className="form-control mt-2 mx-auto"
                required
              />
              <div
                className="invalid-feedback text-start mt-3"
                style={{ marginRight: "63px" }}
              >
                لطفا کد دریافتی را وارد کنید
              </div>
              <label
                htmlFor="number"
                className="text-start  d-block my-3"
                style={{ marginRight: "63px", color: "#1D3354" }}
              >
                کد دریافتی را وارد کنید
              </label>
            </div>
            {/* <div className="d-flex justify-content-center px-3 mt-2 pt-4">
              <div className="w-100" style={{ textAlign: "center" }}>
                <button
                  type="submit"
                  style={{
                    height: "50px",
                    borderRadius: "15px",
                    backgroundColor: "#ff4734",
                    color: "white",
                  }}
                  className="btn  mb-3 w-75 mx-auto"
                >
                  ارسال
                </button>
              </div>
            </div> */}
            <div className="d-flex justify-content-between align-items-end px-3 mt-5 pt-4">
              <div className="w-100" style={{ textAlign: "center" }}>
                <button
                  type="submit"
                  style={{
                    height: "50px",
                    borderRadius: "15px",
                    backgroundColor: "#ff4734",
                    color: "white",
                  }}
                  className="btn  mb-3 w-75 mx-auto"
                >
                  ارسال
                </button>
              </div>
            </div>
          </div>
          <Lottie
            className="img-login"
            loop
            animationData={Login_LogoMotion}
            play
          />
        </div>
      </div>
    </form>
  );
}
